<script setup>
import { computed } from 'vue';
import { getContrastingTextColor } from '@chatwoot/utils';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const visitorColor = computed(
  () => props.config.visitorBubbleColor || props.config.color
);
const visitorStyle = computed(() => ({
  background: visitorColor.value,
  color: getContrastingTextColor(visitorColor.value),
}));
const agentStyle = computed(() => {
  if (!props.config.agentBubbleColor) return undefined;
  return {
    background: props.config.agentBubbleColor,
    color: getContrastingTextColor(props.config.agentBubbleColor),
  };
});
</script>

<template>
  <div class="h-[calc(2rem*10)] px-4 overflow-y-auto">
    <div>
      <div>
        <div
          class="items-end flex justify-end ml-auto mb-1 mt-0 max-w-[85%] text-right"
        >
          <div
            class="rounded-[1.25rem] rounded-br-[0.25rem] text-white dark:text-white text-sm px-4 py-3"
            :style="visitorStyle"
          >
            <p class="m-0">
              {{ $t('INBOX_MGMT.WIDGET_BUILDER.BODY.USER_MESSAGE') }}
            </p>
          </div>
        </div>
      </div>

      <div
        class="shadow rounded-[1.25rem] rounded-bl-[0.25rem] px-4 py-3 inline-block text-sm text-n-slate-12 bg-n-background dark:bg-n-solid-3"
        :style="agentStyle"
      >
        <div>
          <p class="m-0">
            {{ $t('INBOX_MGMT.WIDGET_BUILDER.BODY.AGENT_MESSAGE') }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
